"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminReindex = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const checkbox_1 = require("../../../components/checkbox/checkbox");
const table_field_1 = require("../../../components/table-field/table-field");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const admin_reindex_hooks_1 = require("./admin-reindex-hooks");
const CheckboxSelectAll = ({ checked, setRepositories, }) => {
    return (react_1.default.createElement(checkbox_1.Checkbox, { value: checked, onChange: () => {
            setRepositories((repositories) => repositories.map((repository) => ({
                ...repository,
                active: !checked,
            })));
        } }));
};
function AdminReindex() {
    const [repositories, setRepositories] = (0, admin_reindex_hooks_1.useRepositories)();
    const { loading, reindex } = (0, admin_reindex_hooks_1.useReindex)();
    const CheckboxCell = (0, react_1.useMemo)(() => function CheckboxCell({ value, index, }) {
        return (react_1.default.createElement(checkbox_1.Checkbox, { value: value, onChange: () => {
                setRepositories((repositories) => repositories.map((repository, i) => i === index
                    ? { ...repository, active: !repository.active }
                    : repository));
            } }));
    }, []);
    const columns = [
        {
            name: (react_1.default.createElement(CheckboxSelectAll, { checked: repositories.every((repository) => repository.active), setRepositories: setRepositories })),
            datakey: 'active',
            width: 100,
            CellComponent: CheckboxCell,
        },
        {
            name: 'Repository',
            datakey: 'name',
            width: 500,
        },
    ];
    const reindexSelected = (0, event_callback_hook_1.useEventCallback)(async () => {
        return await reindex(repositories);
    });
    return (react_1.default.createElement(Grid_1.default, { container: true },
        react_1.default.createElement(Grid_1.default, { item: true, xs: false, sm: 1 }),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 10 },
            react_1.default.createElement(Box_1.default, { height: 20 }),
            react_1.default.createElement(table_field_1.TableField, { maxRows: 15, showToolbar: false, showRadioCond: () => false, value: repositories, columns: columns, onChange: lodash_1.noop }),
            react_1.default.createElement(Box_1.default, { height: 20 })),
        react_1.default.createElement(Grid_1.default, { item: true, xs: false, sm: 1 }),
        react_1.default.createElement(Grid_1.default, { item: true, xs: false, sm: 1 }),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 10 },
            react_1.default.createElement(Box_1.default, { display: "flex", flexDirection: "row-reverse" },
                react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", type: "submit", disabled: loading, startIcon: loading && react_1.default.createElement(CircularProgress_1.default, { size: "20px", color: "inherit" }), onClick: reindexSelected },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DEVTOOLS_REINDEX_BTN_REINDEX", defaultMessage: "Reindexovat" })))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: false, sm: 1 })));
}
exports.AdminReindex = AdminReindex;
//# sourceMappingURL=admin-reindex.js.map